import { PromoteSuperAdminModal } from 'TeamModule/components/PromoteSuperAdminModal';
import { useDynamicModal } from 'components/DynamicModalProvider/useDynamicModal';
import { ComponentProps, useCallback } from 'react';

export const usePromoteSuperAdminModal = () => {
  const { openModal } = useDynamicModal();

  const openPromoteSuperAdminModal = useCallback(
    (args: Omit<ComponentProps<typeof PromoteSuperAdminModal>, 'onClose'>) => {
      openModal({
        modal: ({ isOpen: _isOpen, toggle }) => {
          return <PromoteSuperAdminModal onClose={toggle} {...args} />;
        },
      });
    },
    [openModal],
  );

  return {
    openPromoteSuperAdminModal,
  };
};
